/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BarChart } from "../models/http/charts/bar-chart/bar-chart.model";
import { LineChart } from "../models/http/charts/line-chart/line-chart.model";
import { AdvancedFilters } from "../models/http/dashboard/advanced-filters.model";
import { KPI } from "../models/http/dashboard/kpi.model";
import { ChartResponse } from "../models/ui/charts.model";
import { DashboardEnergyHttpService } from "./http/dashboard-energy-http.service";

@Injectable({
	providedIn: "root"
})
export class DashboardEnergyService {
	constructor(private _dashboardEnergyHttpService: DashboardEnergyHttpService) {}

	/**
	 * Fetches the worst 10 layers based on the provided parameters.
	 *
	 * @param filters - The AdvancedFilters request body.
	 * @returns An observable containing the response from the service call.
	 */
	public getWorst10Layers(filters: AdvancedFilters): Observable<ChartResponse<BarChart>> {
		return this._dashboardEnergyHttpService.getWorst10Layers(filters);
	}

	/**
	 * Retrieves the worst 10 applications based on energy consumption within a specified date range.
	 *
	 * @param filters - The AdvancedFilters request body.
	 * @returns An observable containing the response from the server with the worst 10 applications.
	 */
	public getWorst10Apps(filters: AdvancedFilters): Observable<ChartResponse<BarChart>> {
		return this._dashboardEnergyHttpService.getWorst10Apps(filters);
	}

	/**
	 * Fetches the performance data of applications within a specified date range.
	 *
	 * @param filters - The AdvancedFilters request body.
	 * @returns An observable containing the performance data of the applications.
	 */
	public getAppsPerformance(filters: AdvancedFilters): Observable<ChartResponse<LineChart>> {
		return this._dashboardEnergyHttpService.getAppsPerformance(filters);
	}

	public getTotalCO2(filters: AdvancedFilters): Observable<KPI> {
		return this._dashboardEnergyHttpService.getTotalCO2(filters);
	}
}
